import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { APIEndpoints } from "../../config";

interface IProps {
  registry_id: string; // "application/pdf" "image/*"
  content_type: string; // "application/pdf" "image/*"
  file_name: string;
  individual_id: string;
  file_field: string;
}

const makeApiRequest = (createData: IProps) => {
  const postData = {
    body: createData,
  };

  return API.post(
    APIEndpoints.private,
    "/api/v1/registries/request-individual-file",
    postData
  );
};

export const usePostFetchIndividualFile = (retry = 2) => {
  return useMutation<string, AxiosError, IProps>(
    (createData) => makeApiRequest(createData),
    {
      retry,
    }
  );
};
